var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "form",
    {
      staticClass: "form site-search",
      attrs: { role: "search" },
      on: {
        submit: function ($event) {
          $event.preventDefault()
          return _vm.search.apply(null, arguments)
        },
      },
    },
    [
      _c("label", { staticClass: "visually-hidden", attrs: { for: _vm.id } }, [
        _vm._v(_vm._s(_vm.label)),
      ]),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.SearchTerm,
            expression: "SearchTerm",
          },
        ],
        staticClass: "site-search__term",
        attrs: {
          id: _vm.id,
          type: "search",
          placeholder: _vm.label,
          "data-tsat": "t06-site-search",
        },
        domProps: { value: _vm.SearchTerm },
        on: {
          keyup: _vm.handleSearchInput,
          input: function ($event) {
            if ($event.target.composing) return
            _vm.SearchTerm = $event.target.value
          },
        },
      }),
      _vm._v(" "),
      _c("input", {
        staticClass: "btn site-search__btn",
        attrs: {
          type: "submit",
          value: "Search",
          "data-tsat": "t06-site-search-btn",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }